module.exports = __webpack_public_path__ + "media/images/webpage/shared/sale/cover-640x360-66143044c0b1b7db777bf4b4aa44d7fb.webp";